<template>
  <div class="column" :class="columnSize">
    <base-select
      :service="service"
      :fetch-func="fetchFunc"
      :fetch-params="fetchParams"
      :response-handler="responseHandler"
      :custom-filter="customFilter"
      :denormalize="denormalize"
      :label="label"
      :value-key="valueKey"
      :label-key="labelKey"
      :horizontal="horizontal"
      :small="true"
      :type="active ? 'is-info' : ''"
      :custom-class="active ? 'has-text-info' : ''"
      :value="value"
      :name="name"
      :preselect-on-one="preselectOnOne"
      :fetch-on-init="fetchOnInit"
      :disabled="disabled"
      :grouped="grouped"
      :group-by="groupBy"
      :group-labels="groupLabels"
      @input="onInput"
      ref="baseSelect"
    >
      <template v-slot:defaultOptionLabel>{{ defaultOptionLabel }}</template>
      <template #customLabel="{ option }" v-if="customLabel">
        {{ customLabel(option) }}
      </template>
    </base-select>
  </div>
</template>

<script>
import BaseSelect from "@/components/partials/BaseSelect";

export default {
  props: {
    service: {
      type: Function,
      required: true
    },
    fetchFunc: {
      type: String,
      required: true
    },
    fetchParams: {
      type: Object | String,
      default: () => {}
    },
    responseHandler : {
      type: Function,
      required: false,
    },
    denormalize: {
      type: Boolean,
      default: true
    },
    customFilter : {
      type: Function,
      required: false,
    },
    label: {
      type: String
    },
    value: {
      type: String
    },
    valueKey: {
      type: String
    },
    labelKey: {
      type: String
    },
    active: {
      type: Boolean,
      default: false
    },
    horizontal: {
      type: Boolean,
      default: true
    },
    columnSize: {
      type: Object | String,
      default: "is-12"
    },
    customLabel: {
      type: Function
    },
    name: {
      type: String
    },
    defaultOptionLabel: {
      type: String,
      default: "All"
    },
    preselectOnOne: {
      type: Boolean,
      default: false
    },
    fetchOnInit: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    grouped: {
      type: Boolean,
      default: false,
    },
    groupBy: {
      type: String
    },
    groupLabels: {
      type: Object,
    },
  },
  components: {
    BaseSelect
  },
  methods: {
    fetchOptions() {
      this.$refs.baseSelect.fetchOptions();
    },
    clearOptions() {
      this.$refs.baseSelect.clearOptions();
    },
    onInput(value) {
      this.$emit("input", value);
      this.$emit("update:value", value);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/OrderFilter/Field/OrderFilterFieldSelect.vue